import React, { useState, useEffect } from "react";
import SweetAlert from "react-bootstrap-sweetalert";
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import dayjs from "dayjs";
import { Action } from "../../../constants/Common";
import { ChangeRequestModule } from "../../../constants/Module";
import { toast } from "react-toastify";
import { withTranslation } from "react-i18next";


const IndividualMilestone = (props) => {
  const [openAlert, setOpenAlert] = useState(false);
  const [milestoneBudget, setMilestoneBudget] = useState()

  useEffect(() =>{
      if(props?.eachMilestone){
          setMilestoneBudget(props?.action === Action.CREATE ? props?.eachMilestone?.items : props?.eachMilestone?.items?.new)
      }
  },[])

  const handleKeyDownWeight = (event) => {

    if (event.keyCode === 8 || event.keyCode === 13) {
      return;
    }
   
    const regex = /^[0-9]+$/;

    if (!regex.test(event.key)) {
      event.preventDefault(); 
    }
  }

  const dateValidation =() =>{
    if(props.updatedDeliverable){
        if(typeof props?.eachMilestone?.estimatedStartDate === 'object' && props?.eachMilestone?.estimatedStartDate?.old < props.updatedDeliverable?.startDate?.new ){
            return toast.error(`Deliverable ${props?.updatedDeliverable.name} start date ${dayjs(props?.updatedDeliverable?.startDate.new).format('MM/DD/YYYY')} cannot be greater than milestone start date ${dayjs(props?.eachMilestone?.estimatedStartDate?.old).format('MM/DD/YYYY')}`);
        }
        if(typeof props?.eachMilestone?.estimatedEndDate === 'object' && props?.eachMilestone?.estimatedEndDate?.old > props.updatedDeliverable?.endDate?.new ){
            return toast.error(`Deliverable ${props?.updatedDeliverable.name} end date ${dayjs(props?.updatedDeliverable?.endDate.new).format('MM/DD/YYYY')} cannot be less than milestone end date ${dayjs(props?.eachMilestone?.estimatedEndDate?.old).format('MM/DD/YYYY')}`);
        }
    }
    setOpenAlert(true); 
}

  return (
    <div className="editDeliverable_height h-auto my-4">
      <div className="dashed_border position-relative p-2">
        <div className="row">
          <div className="col-md-12 mt-2">
            <TextField
              fullWidth
              id="outlined-multiline-static"
              label={props.t("Name")}
              name="name"
              inputProps={{
                readOnly: true
              }}
              required
              variant={`${
                typeof props?.eachMilestone?.name === "object"
                  ? "filled"
                  : "outlined"
              }`}
              value={
                props?.action === Action.CREATE
                  ? props?.eachMilestone?.name ?? ""
                  : typeof props?.eachMilestone?.name === "object"
                  ? props?.eachMilestone?.name?.new
                  : props?.eachMilestone?.name
              }
            />
          </div>
        </div>
        <div className="row">
          <div className="col-md-12 mt-2">
            <TextField
              fullWidth
              id="outlined-multiline-static"
              label={props.t("Description")}
              name="description"
              type="text"
              inputProps={{
                readOnly: true
              }}
              multiline
              variant={`${
                typeof props?.eachMilestone?.description === "object"
                  ? "filled"
                  : "outlined"
              }`}
              value={
                props?.action === Action.CREATE
                  ? props?.eachMilestone?.description ?? ""
                  : typeof props?.eachMilestone?.description === "object"
                  ? props?.eachMilestone?.description?.new
                  : props?.eachMilestone?.description
              }
              required
            />
          </div>
        </div>
        <div className="row">
          <div className="col-md-12 mt-2">
            <TextField
              fullWidth
              id="outlined-multiline-static"
              label={props.t("Assigned Deliverable")}
              name="deliverable"
              disabled={props?.action === Action.UPDATE}
              type="text"
              inputProps={{
                readOnly: true
              }}
              value={
                props?.eachMilestone?.deliverableId
                  ? props?.eachMilestone?.deliverable?.name ??
                    props?.eachMilestone?.deliverableObject?.name
                  : ""
              }
              required
            />
          </div>
        </div>
        <div className="row">
          <div className="col-md-6 mt-2">
            <TextField
              fullWidth
              id="outlined-multiline-static"
              label={props.t("Weight")}
              name="weight"
              onKeyDown={handleKeyDownWeight}
              required
              inputProps={{
                readOnly: true
              }}
              variant={`${
                typeof props?.eachMilestone?.weight === "object"
                  ? "filled"
                  : "outlined"
              }`}
              value={
                props?.action === Action.CREATE
                  ? props?.eachMilestone?.weight >= 0 ? props?.eachMilestone?.weight : ""
                  : typeof props?.eachMilestone?.weight === "object"
                  ? props?.eachMilestone?.weight?.new
                  : props?.eachMilestone?.weight
              }
            />
          </div>
          {/* <div className="col-md-6 mt-2">
            <TextField
              fullWidth
              id="outlined-multiline-static"
              label={props.t("Goal")}
              name="aim"
              required
              inputProps={{
                readOnly: true
              }}
              variant={`${
                typeof props?.eachMilestone?.aim === "object"
                  ? "filled"
                  : "outlined"
              }`}
              value={
                props?.action === Action.CREATE
                  ? props?.eachMilestone?.aim ?? ""
                  : typeof props?.eachMilestone?.aim === "object"
                  ? props?.eachMilestone?.aim?.new
                  : props?.eachMilestone?.aim
              }
            />
          </div> */}
        </div>
        <div className="row">
          <div className="col-md-12 mt-2">
            <TextField
              fullWidth
              id="outlined-multiline-static"
              label={props.t("Output")}
              name="output"
              type="text"
              inputProps={{
                readOnly: true
              }}
              multiline
              variant={`${
                typeof props?.eachMilestone?.output === "object"
                  ? "filled"
                  : "outlined"
              }`}
              value={
                props?.action === Action.CREATE
                  ? props?.eachMilestone?.output ?? ""
                  : typeof props?.eachMilestone?.output === "object"
                  ? props?.eachMilestone?.output?.new
                  : props?.eachMilestone?.output
              }
              required
            />
          </div>
        </div>
        <div className="row">
          <div className=" col-md-6 changeRequest_datePicker mt-2 pe-0">
            <TextField
              fullWidth
              id="outlined-multiline-static"
              label={props.t("Start Date")}
              name="estimatedStartDate"
              required
              inputProps={{
                readOnly: true
              }}
              variant={`${
                typeof props?.eachMilestone?.estimatedStartDate === "object"
                  ? "filled"
                  : "outlined"
              }`}
              value={
                props?.action === Action.CREATE
                  ? (props?.eachMilestone?.estimatedStartDate
                      ? dayjs(props?.eachMilestone?.estimatedStartDate)
                      : ""
                    ).format("DD-MM-YYYY")
                  : typeof props?.eachMilestone?.estimatedStartDate ===
                      "object" && props?.eachMilestone?.estimatedStartDate?.new
                  ? dayjs(props?.eachMilestone?.estimatedStartDate?.new).format(
                      "DD-MM-YYYY"
                    )
                  : props?.eachMilestone?.estimatedStartDate
                  ? dayjs(props?.eachMilestone?.estimatedStartDate).format(
                      "DD-MM-YYYY"
                    )
                  : ""
              }
            />
          </div>
          <div className="col-md-6 changeRequest_datePicker mt-2">
            <TextField
              fullWidth
              id="outlined-multiline-static"
              label={props.t("End Date")}
              name="estimatedEndDate"
              required
              inputProps={{
                readOnly: true
              }}
              variant={`${
                typeof props?.eachMilestone?.estimatedEndDate === "object"
                  ? "filled"
                  : "outlined"
              }`}
              value={
                props?.action === Action.CREATE
                  ? props?.eachMilestone?.estimatedEndDate
                    ? dayjs(props?.eachMilestone?.estimatedEndDate).format(
                        "DD-MM-YYYY"
                      )
                    : ""
                  : typeof props?.eachMilestone?.estimatedEndDate ===
                      "object" && props?.eachMilestone?.estimatedEndDate?.new
                  ? dayjs(props?.eachMilestone?.estimatedEndDate?.new).format(
                      "DD-MM-YYYY"
                    )
                  : props?.eachMilestone?.estimatedEndDate
                  ? dayjs(props?.eachMilestone?.estimatedEndDate).format(
                      "DD-MM-YYYY"
                    )
                  : ""
              }
            />
          </div>
        </div>
        <div className="row mt-2">
          <div className="col-md-12">
              <p className="title">{props.t('Cost')}: &nbsp; SAR {props?.action === Action.CREATE ? parseFloat(props?.eachMilestone?.cost).toFixed(2) ?? '0.00' : typeof props?.eachMilestone?.cost === 'object' ? props?.eachMilestone?.cost?.new.toFixed(2) : props?.eachMilestone?.cost.toFixed(2)}</p>
          </div>
        </div>
        {milestoneBudget?.length > 0 &&
            milestoneBudget.map((_row, index) => ( 
            <>
            <div className="row" key={index}>
            <div className=" col-md-6 mt-2 pe-0 plCurrency currency_small_font">
                    {/* <TextField
                        sx={{ marginLeft: 3 }}
                        size="small"
                        label={props.t("Planned Cost")}
                        variant={`${
                          props?.action === Action.CREATE
                            ? "outlined"
                            : (!_row?.id || props?.eachMilestone?.items?.old.find((item) => item?.id === _row?.id && _row?.plannedCost !== item?.plannedCost) ) ? "filled" : "outlined"
                        }`}
                        InputProps={{
                            startAdornment: <InputAdornment position="start">SAR</InputAdornment>,
                        }}
                        fullWidth
                        value={_row.plannedCost}
                        inputProps={{
                            readOnly: true
                        }}
                        className="m-0"
                    /> */}
                    <TextField
                      minimumValue="0"
                      sx={{ marginLeft: 3 }}
                      id="milestone-cost"
                      variant={`${
                        props?.action === Action.CREATE
                        ? "outlined"
                        : (!_row?.id || props?.eachMilestone?.items?.old.find((item) => item?.id === _row?.id && _row?.plannedCost !== item?.plannedCost) ) ? "filled" : "outlined"
                      }`}
                      // label='Deliverable Cost'
                    // size="small"
                    decimalPlaces={2}
                    value={_row.plannedCost}
                    name = "plannedCost"
                    currencySymbol={props.t("SAR")}
                    fullWidth
                    placeholder={props.t("Planned cost of budget")}
                    inputProps={{
                      readOnly: true
                    }}
                  />
                </div>
                <div className=" col-md-6 mt-2 pe-0">
                    <TextField
                        label={`${_row.type !== 'Others' ? props.t('Budget Type') : props.t('Custom Budget Type')} `}
                        variant={`${
                          props?.action === Action.CREATE
                            ? "outlined"
                            : (!_row?.id || props?.eachMilestone?.items?.old.find((item) => item?.id === _row?.id && _row?.budgetType !== item?.budgetType) ) ? "filled" : "outlined"
                        }`}
                        size="small"
                        fullWidth
                        value={_row.budgetType}
                        inputProps={{
                            readOnly: true
                        }}
                    />
                </div>
              
            </div>
            </>
          )
        )}
        <div className="d-flex justify-content-end align-items-center mt-2 mx-2">
          <button
            className="edit_button"
            onClick={() => {
              if(props.action === Action.UPDATE && (typeof props?.eachMilestone?.estimatedStartDate === 'object' || typeof props?.eachMilestone?.estimatedEndDate === 'object')){
                dateValidation()      
              } else{
                setOpenAlert(true); 
              } 
            }}
          >
            {props.t('Delete')}
          </button>
        </div>
      </div>
      {openAlert && (
        <SweetAlert
          title={props.t("Are you sure you want to delete this milestone") + '?'}
          warning
          showCancel
          confirmBtnText={props.t("OK")}
          cancelBtnText={props.t("Cancel")}
          confirmBtnBsStyle="success"
          cancelBtnBsStyle="danger"
          onConfirm={() => {
            setOpenAlert(false);
            props?.removeItemFromPayload(
              {
                ...props?.eachMilestone,
                event: props?.action,
                module: ChangeRequestModule.MILESTONE,
              },
              props?.eachMilestoneIndex
            );
          }}
          onCancel={() => {
            setOpenAlert(false);
          }}
        ></SweetAlert>
      )}
    </div>
  );
};

export default withTranslation() (IndividualMilestone);
